<template>
    <div class="container bng-narrow-container bng-history">
        <button class="button is-link bng-history-close" @click="goBack"></button>
        <h1 class="title">{{ "components.pages.history.title" | translate }}</h1>

        <div class="field is-horizontal">
            <div v-if="balances.length > 1" class="field-label is-normal">
                <label class="label">{{ "components.pages.history.balance" | translate }}</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div v-if="balances.length > 1" class="select">
                            <select v-model="balance">
                                <option
                                    v-for="balance in balances"
                                    :key="balance.id"
                                    :value="balance"
                                >
                                    <description :obj="balance" />
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">{{ "components.pages.history.date" | translate }}</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input ref="date" class="input date" type="text" readonly />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tabs">
            <ul>
                <router-link v-for="link in links" :key="link.name" :to="link.route" tag="li">
                    <a>{{link.text | translate}}</a>
                </router-link>
                <router-link :to="{ name: 'history-deposit-withdraw' }" tag="li">
                    <a>{{"components.pages.history.deposit-withdraw.title" | translate}}</a>
                </router-link>
                <router-link :to="{ name: 'history-bonus' }" tag="li">
                    <a>{{"components.pages.history.bonus.title" | translate}}</a>
                </router-link>
                <router-link :to="{ name: 'history-all' }" tag="li">
                    <a>{{"components.pages.history.all.title" | translate}}</a>
                </router-link>
            </ul>
        </div>

        <router-view v-if="balance && date" />
    </div>
</template>
<script>
import Vue from 'vue';
import moment from 'moment-timezone';

import balanceService from '../../../../../../_common/services/balance.service';
import utils from '../../../../../../_common/utils';
import menuHelper from '../../../../helpers/menu.helper';

import Description from '../../../common/description/description.vue';

import pushService from '../../../../../../_common/services/push.service';

export default {
    name: 'history',
    components: { Description },
    data() {
        return {
            links: null,
            balances: [],
            calendar: null,
            backRoute: null
        };
    },
    computed: {
        balance: {
            get: () => Vue.state.history.balance.get(),
            set: b => Vue.state.history.balance.set(b)
        },
        date: {
            get: () => Vue.state.history.date.get(),
            set: d => Vue.state.history.date.set(d)
        },
        endOfToday: () => moment(new Date()).endOf('day').toDate()
    },
    async created() {
        this.links = await menuHelper.getHistoryLinks();

        // balance
        this.balances = await balanceService.getAllBalances();
        if (this.balances.length) {
            this.balance = this.balances.find(b => b.isActive);
        }

        // date
        this.date = this.endOfToday;
        let self = this;
        let calendarOptions = {
            defaultDate: this.date,
            enableTime: false,
            disableMobile: 'true',
            onOpen: function(selectedDates, dateStr, instance) {
                setTimeout(function() {
                    instance.open();
                }, 200);
            },
            onChange: function(selectedDates, dateStr, instance) {
                self.date = moment(selectedDates[0]).endOf('day').toDate();
            }
        };
        this.calendar = flatpickr(this.$refs.date, calendarOptions);
    },
    mounted() {
        this.backRoute = Vue.state.route.from.get() || '/';
    },
    methods: {
        currentDate() {},
        goBack() {
            const backPath = this.backRoute || '/';
            this.$router.push(backPath);
        }
    },
    beforeDestroy() {
        this.balance = null;
        this.date = this.endOfToday;
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/history/history.vue